<template>
  <img src="~/assets/icon/icon-visa.svg" />
</template>
